<div class="container-fluid top">
  <dm-header></dm-header>
  <router-outlet></router-outlet>
</div>

<div class="bottom">
  <dm-footer></dm-footer>
</div>
